const Plus = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M20.0007 36.6667C29.2054 36.6667 36.6673 29.2048 36.6673 20C36.6673 10.7953 29.2054 3.33337 20.0007 3.33337C10.7959 3.33337 3.33398 10.7953 3.33398 20C3.33398 29.2048 10.7959 36.6667 20.0007 36.6667ZM21.2507 15C21.2507 14.3097 20.691 13.75 20.0007 13.75C19.3103 13.75 18.7507 14.3097 18.7507 15L18.7507 18.7501H15.0007C14.3103 18.7501 13.7507 19.3097 13.7507 20.0001C13.7507 20.6904 14.3103 21.2501 15.0007 21.2501H18.7507V25C18.7507 25.6904 19.3103 26.25 20.0007 26.25C20.691 26.25 21.2507 25.6904 21.2507 25L21.2507 21.2501H25.0007C25.691 21.2501 26.2507 20.6904 26.2507 20.0001C26.2507 19.3097 25.691 18.7501 25.0007 18.7501H21.2507V15Z" fill="url(#paint0_linear_272_3179)" />
            <defs>
                <linearGradient id="paint0_linear_272_3179" x1="20.0007" y1="3.33337" x2="20.0007" y2="19.8427" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1C225A" />
                    <stop offset="1" stopColor="#3B49C0" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Plus